import {COLORS, FONT_SIZES, FONT_WEIGHTS, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

interface Props {
  infoBox?: {
    headline: string;
    subline: string;
  };
}
export const HotProductBanner: React.FC<Props> = ({infoBox}) => {
  if (!infoBox) {
    return null;
  }

  return (
    <HotDealsWrapper data-testid="hotProductBanner">
      <StyledHeadline>🔥 {infoBox.headline} 🔥</StyledHeadline>
      <StyledSubline>{infoBox.subline}</StyledSubline>
    </HotDealsWrapper>
  );
};

const HotDealsWrapper = styled.div`
  padding: 4px 40px;
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-color: ${COLORS.Grey3};
  margin: 16px 0;
  text-align: center;
  position: relative;
  ::before,
  ::after {
    content: '';
    position: absolute;
    width: 40px;
    top: -1px;
    bottom: -1px;
  }

  ::before {
    left: 0;
    background: linear-gradient(
      90deg,
      #ffffff 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }
  ::after {
    right: 0;
    background: linear-gradient(
      270deg,
      #ffffff 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`;

const StyledHeadline = styled(Text)`
  display: block;
  line-height: 18px;
  font-size: ${FONT_SIZES.px12};
  text-transform: uppercase;
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
`;

const StyledSubline = styled(Text)`
  display: block;
  font-size: ${FONT_SIZES.px10};
  color: ${COLORS.Grey1};
  line-height: 16px;
`;
